import script from "./Incidents.vue?vue&type=script&setup=true&lang=js"
export * from "./Incidents.vue?vue&type=script&setup=true&lang=js"

import "./Incidents.vue?vue&type=style&index=0&id=23965a1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23965a1b"]])

export default __exports__